export const ORDR_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "requiredQuantity", "qohQuantityByFacility", "atpQuantityByFacility", "qohQuantity", "atpQuantity", "onOrderQuantity", "inProductionQuantity", "unplannedQuantity", "reserveAfterDate", "currentItemStatus", "quantity", "itemReservedQuantity", "cancelQuantity", "pickedQty", "remainingQuantity", "shippedQuantity", "shortfalledQuantity", "orderInvoiced", "orderReturned", "unitPrice", "unitListPrice", "adjustments", "subTotal" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "itemDescription",
            "title" : "Description"
          },{
            "name" : "requiredQuantity",
            "title" : "Required for SO"
        }, {
            "name" : "qohQuantityByFacility",
            "title" : "In Inventory [] QOH"
        }, {
            "name" : "atpQuantityByFacility",
            "title" : "ATP"
        }, {
            "name" : "qohQuantity",
            "title" : "In Inventory [All Facilities] QOH"
        }, {
            "name" : "atpQuantity",
            "title" : "ATP"
        }, {
            "name" : "onOrderQuantity",
            "title" : "On Order"
        }, {
            "name" : "inProductionQuantity",
            "title" : "In Production"
        }, {
            "name" : "unplannedQuantity",
            "title" : "Unplanned"
        }, {
            "name" : "reserveAfterDate",
            "title" : "Reserve After Date"
        }, {
            "name" : "currentItemStatus",
            "title" : "Item Status"
        }, {
            "name" : "quantity",
            "title" : "Ordered"
        }, {
            "name" : "itemReservedQuantity",
            "title" : "Ship Request"
        }, {
            "name" : "cancelQuantity",
            "title" : "Cancelled"
        }, {
            "name" : "pickedQty",
            "title" : "Qty Picked"
        }, {
            "name" : "remainingQuantity",
            "title" : "Remaining"
        }, {
            "name" : "shippedQuantity",
            "title" : "Qty Shipped"
        }, {
            "name" : "shortfalledQuantity",
            "title" : "Shortfalled"
        }, {
            "name" : "orderInvoiced",
            "title" : "Invoiced"
        }, {
            "name" : "orderReturned",
            "title" : "Returned"
        }, {
            "name" : "unitPrice",
            "title" : "Item Unit Price"
        }, {
            "name" : "unitListPrice",
            "title" : "Item Unit List Price"
        }, {
            "name" : "adjustments",
            "title" : "Item Adjustments"
        }, {
            "name" : "subTotal",
            "title" : "Sub Total"
        } ],
        "formName" : "OrderItems",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "WSCO10731",
            "style" : "",
            "id" : "OrderItems_orderId",
            "title" : "Order ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            name:"identification",
            title:"Identification",
            type:"COMPOSITE",
            innerFields:[{
                "name" : "productId",
                "title" : "Product ID",
            },{
                "name" : "itemDescription",
                "title" : "Description",
            }]

        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_productId",
            "title" : "Product ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
          },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "itemDescription",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_itemDescription",
            "title" : "Description",
            "type" : "HIDDEN",
            "imageLocation" : ""
          },{
            name:"inventory",
            title:"Inventory",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "qohQuantityByFacility",
                    "title" : "In Inventory [] QOH"
                }, {
                    "name" : "atpQuantityByFacility",
                    "title" : "ATP"
                }, {
                    "name" : "qohQuantity",
                    "title" : "In Inventory [All Facilities] QOH"
                }, {
                    "name" : "atpQuantity",
                    "title" : "ATP"
                },{
                    "name" : "onOrderQuantity",
                    "title" : "On Order"
                }, {
                    "name" : "inProductionQuantity",
                    "title" : "In Production"
                }
            ]
        }, {
            name:"quantities",
            title:"Quantities",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "quantity",
                    "title" : "Ordered"
                }, {
                    "name" : "itemReservedQuantity",
                    "title" : "Ship Request"
                }, {
                    "name" : "cancelQuantity",
                    "title" : "Cancelled"
                }, {
                    "name" : "pickedQty",
                    "title" : "Qty Picked"
                }, {
                    "name" : "remainingQuantity",
                    "title" : "Remaining"
                }, {
                    "name" : "shippedQuantity",
                    "title" : "Qty Shipped"
                }, {
                    "name" : "shortfalledQuantity",
                    "title" : "Shortfalled"
                }, {
                    "name" : "requiredQuantity",
                    "title" : "Required for SO"
                }, {
                    "name" : "unplannedQuantity",
                    "title" : "Unplanned"
                }
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "requiredQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_requiredQuantity",
            "title" : "Required for SO",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "qohQuantityByFacility",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_qohQuantityByFacility",
            "title" : "In Inventory [] QOH",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "atpQuantityByFacility",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_atpQuantityByFacility",
            "title" : "ATP",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "qohQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_qohQuantity",
            "title" : "In Inventory [All Facilities] QOH",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "atpQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_atpQuantity",
            "title" : "ATP",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "onOrderQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_onOrderQuantity",
            "title" : "On Order",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "inProductionQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_inProductionQuantity",
            "title" : "In Production",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "unplannedQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_unplannedQuantity",
            "title" : "Unplanned",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "reserveAfterDate",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_reserveAfterDate",
            "title" : "Reserve After Date",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currentItemStatus",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_currentItemStatus",
            "title" : "Item Status",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_quantity",
            "title" : "Ordered",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "itemReservedQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_itemReservedQuantity",
            "title" : "Ship Request",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cancelQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_cancelQuantity",
            "title" : "Cancelled",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "pickedQty",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_pickedQty",
            "title" : "Qty Picked",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "remainingQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_remainingQuantity",
            "title" : "Remaining",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shippedQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_shippedQuantity",
            "title" : "Qty Shipped",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shortfalledQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_shortfalledQuantity",
            "title" : "Shortfalled",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderInvoiced",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_orderInvoiced",
            "title" : "Invoiced",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderReturned",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_orderReturned",
            "title" : "Returned",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "unitPrice",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_unitPrice",
            "title" : "Item Unit Price",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "unitListPrice",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_unitListPrice",
            "title" : "Item Unit List Price",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "adjustments",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_adjustments",
            "title" : "Item Adjustments",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            name:"item",
            title:"Item",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "unitPrice",
                    "title" : "Item Unit Price"
                }, {
                    "name" : "unitListPrice",
                    "title" : "Item Unit List Price"
                }, {
                    "name" : "adjustments",
                    "title" : "Item Adjustments"
                } 
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "subTotal",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_subTotal",
            "title" : "Sub Total",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    
]
